import { useCallback } from 'react';
import isEqual from 'lodash/isEqual';

type HandleClickPutInCart = (selectedIdx: number) => void;

const useAddTicketIncart = (
  membershipData: MemberShipDataTypes[] | undefined,
  cartData: MemberShipDataTypes[],
  setCartData: React.Dispatch<React.SetStateAction<MemberShipDataTypes[]>>
): HandleClickPutInCart => {
  const handleClickPutInCart: HandleClickPutInCart = useCallback(
    (selectedIdx: number) => {
      if (!membershipData) return;

      const updatedCartData = [...cartData];
      const selectedItem = membershipData.find((item) => item.uuid === selectedIdx);

      if (selectedItem) {
        const selectedItemIndex = updatedCartData.findIndex((item) => item.uuid === selectedIdx);
        const selectedDivisionData = selectedItem.divisiondata;

        const isLicenseTicket = selectedItem?.licenseData ? true : false;

        if (selectedItemIndex !== -1 && selectedItem.editable && !isLicenseTicket) {
          let isSameDivisionDataExist = false;

          for (let i = 0; i < updatedCartData.length; i++) {
            if (
              updatedCartData[i].uuid === selectedIdx &&
              isEqual(updatedCartData[i].divisiondata, selectedDivisionData)
            ) {
              updatedCartData[i].count++;
              isSameDivisionDataExist = true;
              break;
            }
          }

          if (!isSameDivisionDataExist) {
            updatedCartData.push({ ...selectedItem, cart: true, count: 1 });
          }
        } else {
          if (selectedItemIndex !== -1 && !selectedItem.editable) {
            updatedCartData[selectedItemIndex].count++;
          } else if (isLicenseTicket) {
            const licenseItemIndex = updatedCartData.findIndex(
              (item) => item.uuid === selectedIdx && item.licenseData
            );

            if (licenseItemIndex === -1) {
              updatedCartData.push({
                ...selectedItem,
                cart: true,
                count: selectedItem?.licenseData?.count
              });
            }
          } else {
            updatedCartData.push({ ...selectedItem, cart: true, count: 1 });
          }
        }

        setCartData(updatedCartData);
      }
    },
    [cartData, membershipData, setCartData]
  );

  return handleClickPutInCart;
};

export default useAddTicketIncart;
